<template lang="pug">
    Tabs.member-list.pagination
        el-card.contains-table( shadow="always" )
            .error(v-if="error")
                template(v-if="error.code")
                    Error(:message="$t(error.message || 'Something went wrong!')" :code="error.code")
                template(v-else)
                    Error(:message="$t('Something went wrong!')" :code="501")
            .members-table(v-else)
                //- :row-link-config="productsPaginated.link"
                paginated-items(
                    scope="ex"
                    type="rstrct_member"
                    :loading="loading"
                    :items="membersPaginated.items"
                    :filters="filters"
                    :show-filters="showFilters"
                    :variables="membersPaginated.variables"
                    :all-columns="allColumns"
                    :active-columns="activeColumns"
                    :page-info="membersPaginated.pageInfo"
                    :sort="sort"
                    @pagination-size-change="handleSizeChange"
                    @pagination-current-change="handleCurrentChange"
                    @show-table-columns="handleColsShow"
                    @change-filter="handleFilterInputChange"
                    @click="handleClick"
                    @change-sort="handleSortInputChange"
                )
                    template(slot="top")
                        el-row.table-top(v-loading="loading" type="flex" justify="space-between")
                            .row
                                .left
                                    el-button(type="primary" size="mini" icon="el-icon-fa-plus fas" @click="addMember")
                                        | {{ $t('New Person') }}

                                    el-button(
                                        v-if="enabledExtensions.includes('shop') || enabledExtensions.includes('newsletter')"
                                        plain
                                        type="primary"
                                        size="mini"
                                        icon="el-icon-fa-download fas"
                                        @click="toggleTransferForm({ key: 'csv' }, 'csv-member-import')"
                                    )
                                        | {{ $t(csvImportLabel) }}

                                    //- member transfers

                                    template(v-if="memberTransfers.length")
                                        el-button(
                                            v-for="config in memberTransfers"
                                            :key="`members-${config.key}`"
                                            plain
                                            type="primary"
                                            size="mini"
                                            :icon="config.type === 'import' ? 'el-icon-fa-download fas' : 'el-icon-fa-upload fas'"
                                            @click="toggleTransferForm(config, 'members')"
                                        )
                                            | {{ config.name }}

                                    //- customer transfers

                                    template(v-if="customerTransfers.length")
                                        el-button(
                                            v-for="config in customerTransfers"
                                            :key="`customers-${config.key}`"
                                            plain
                                            type="primary"
                                            size="mini"
                                            :icon="config.type === 'import' ? 'el-icon-fa-download fas' : 'el-icon-fa-upload fas'"
                                            @click="toggleTransferForm(config, 'customers')"
                                        )
                                            | {{ config.name }}
                                .right.hide-on-empty
                                    .bulk-actions
                                        el-select(
                                            v-model="bulk.action"
                                            size="mini"
                                            :placeholder="$t('Select bulk action...')"
                                            clearable
                                        )
                                            el-option(
                                                v-for="item in bulk.options"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value"
                                            )
                                        transition(name="slide-decent-left")
                                            el-button(
                                                v-if="membersPaginated.pageInfo.selection.total > 0 || bulk.action"
                                                type="primary"
                                                size="mini"
                                                :disabled="!bulk.action || membersPaginated.pageInfo.selection.total <= 0"
                                                icon="el-icon-fa-check fas"
                                                @click.stop.prevent="event => handleBulkAction()"
                                            )
                                                | {{ $t('Go') }}
                                    hr.vertical
                                    el-button(
                                        plain
                                        size="mini"
                                        type="primary"
                                        icon="el-icon-fa-filter fas"
                                        @click="toggleFilterVisiblity"
                                        :disabled="disable.showFilters || hasFilters"
                                    )
                                        span(v-if="showFilters") {{ $t('Hide filters') }}
                                        span(v-else) {{ $t('Show filters') }}
                            transition(name="slide-decent-vertical")
                                .transfer(v-if="visibleTransfer")
                                    transition(name="slide-decent-vertical" mode="out-in")
                                        CsvImport(
                                            v-if="visibleTransfer.config.key === 'csv'"
                                            :key="visibleTransfer.config.key"
                                            @refresh="refetch"
                                        )
                                        //- TODO
                                        //- MemberTransfer(v-if="visibleTransfer.scope === 'members'" :config="visibleTransfer.config")
                                        CustomerTransfer(
                                            v-if="visibleTransfer.scope === 'customers'"
                                            :key="visibleTransfer.config.key"
                                            :type="visibleTransfer.config.type"
                                            :disabled="disable.customerTransfer"
                                            :config="visibleTransfer.config"
                                            @refresh="refreshCustomerTransfer"
                                        )
                            transition(name="slide-decent-vertical")
                                .status-logs-container.z-depth-1(v-if="logs.length")
                                    .spinner-container(v-if="loadingLogs")
                                        .spinner
                                    StatusLog(v-for="log in logs" :key="log.id" :log="log")
                                        template(v-if="['success', 'error'].includes(log.status)" slot="actions")
                                            a.is-danger(href="#" @click.prevent="hideStatusLog(log)")
                                                i.el-icon-fa-times.fas
                    template(v-slot:actions:th)
                        .col-left(v-if="!showFilters")
                            check-all(
                                :total="membersPaginated.pageInfo.total"
                                :show-dropdown="membersPaginated.pageInfo.lastPage > 1"
                                :checked="bulkSelection"
                                :is-indeterminate="selectionIndeterminate"
                                @check-all="checkAll"
                                @check-visible="checkVisible"
                            )
                    template(v-slot:actions:filter)
                        .col-left(v-if="showFilters" style="padding-left: 10px")
                            check-all(
                                :total="membersPaginated.pageInfo.total"
                                :show-dropdown="membersPaginated.pageInfo.lastPage > 1"
                                :checked="bulkSelection"
                                :default-event="checkAllEvent"
                                :is-indeterminate="selectionIndeterminate"
                                @check-all="checkAll"
                                @check-visible="checkVisible"
                            )
                    template(v-slot:actions="{ item }")
                        el-checkbox(
                            :key="item.id"
                            :value="isChecked(item.id)"
                            @change="checkItem(item)"
                        )
                        template(v-if="impersonateFeatureEnabled")
                            el-button.impersonate-button(
                                circle
                                plain
                                size="mini"
                                type="info"
                                icon="el-icon-fa-arrow-right-to-bracket fas"
                                @click.stop.prevent="impersonateMember(item.id)"
                            )
                            el-button.hidden.impersonate-button(
                                circle
                                plain
                                size="mini"
                                type="primary"
                                icon="el-icon-fa-arrow-right-to-bracket fas"
                                @click.stop.prevent="impersonateMember(item.id, false)"
                            )
                            el-button.hidden.mimic-button(
                                circle
                                size="mini"
                                type="info"
                                icon="el-icon-fa-sign-in-alt fas"
                                @click.stop.prevent="mimicMember(item.id, false)"
                            )
                        template(v-else-if="mimicFeatureEnabled")
                            el-button.mimic-button(
                                circle
                                size="mini"
                                type="info"
                                icon="el-icon-fa-sign-in-alt fas"
                                @click.stop.prevent="mimicMember(item.id)"
                            )
                    template(v-slot:address_country="{ value }") {{ value | country }}
                    //- template(v-slot:address_country:filter:option-template="{ item }") {{ item.key | country }}
                    template(v-slot:address_country:filter:options-template="{ options }")
                        el-option(
                            v-for="(item, index) in options"
                            :key="item.value || item.key"
                            :label="country(item.label)"
                            :value="item.value || item.key"
                        )
                    template(v-if="filters.address_country" v-slot:address_country:filter:occupy-space="{ options }")
                        div(v-for="value in filters.address_country.in")
                            nobr {{ value | country }}
                        .occupy-select-input-space
                    template(v-slot:tags="{ item }")
                        .tags
                            //- show max 3 tags
                            el-tag(
                                v-if="item.memberTags && item.memberTags.length"
                                v-for="tag in item.memberTags.slice(0, 3)"
                                :key="`${item.id}:${tag.id}`"
                                type="info"
                                effect="dark"
                                size="small"
                            ) {{ tag.name }}
                            template(v-if="item.memberTags && item.memberTags.length > 3")
                                el-popover(
                                    placement="top"
                                    :title="$t('Tags of {name}', { name: item.name })"
                                    trigger="hover"
                                )
                                    .tags.popover-body.mt-2
                                        el-tag(
                                            v-for="tag in item.memberTags"
                                            :key="`popover:${item.id}:${tag.id}`"
                                            type="info"
                                            effect="dark"
                                            size="mini"
                                        ) {{ tag.name }}
                                    el-button(
                                        type="text"
                                        slot="reference"
                                        @click.stop
                                    ) +{{ item.memberTags.length - 3 }}

                    template(v-slot:subscription_topics="{ item }")
                        .tags
                            //- show max 3 tags
                            el-tag(
                                v-if="item.subscriptionTopics && item.subscriptionTopics.length"
                                v-for="tag in item.subscriptionTopics.slice(0, 3)"
                                :key="`${item.id}:${tag.id}`"
                                type="info"
                                effect="dark"
                                size="small"
                            ) {{ tag.name }}
                            template(v-if="item.subscriptionTopics && item.subscriptionTopics.length > 3")
                                el-popover(
                                    placement="top"
                                    :title="$t('Subscription Topics of {name}', { name: item.name })"
                                    trigger="hover"
                                )
                                    .tags.popover-body.mt-2
                                        el-tag(
                                            v-for="tag in item.subscriptionTopics"
                                            :key="`popover:${item.id}:${tag.id}`"
                                            type="info"
                                            effect="dark"
                                            size="mini"
                                        ) {{ tag.name }}
                                    el-button(
                                        type="text"
                                        slot="reference"
                                        @click.stop
                                    ) +{{ item.subscriptionTopics.length - 3 }}

        el-dialog.bulk-action-dialog(
            :title="bulk.modal.title"
            :visible.sync="bulk.modal.visibility"
            :close-on-click-modal="false"
            :width="bulk.modal.width"
            top="10vh"
            @closed="resetBulkModal"
        )
            .bulk-modal-body(v-if="bulk.action === 'export-members'")
                .export-members-fields
                    .field-section-header
                        .field-section-label {{ $t('Basic fields') }}
                        el-button(type="text" size="mini" @click="toggleAllExportFields")
                            | {{ allExportFieldsSelected ? $t('Deselect all') : $t('Select all') }}
                    el-checkbox-group.field-chips(v-model="exportMembers.fields")
                        el-checkbox(
                            v-for="field in exportMembers.basicFields"
                            :key="field.key"
                            :label="field.key"
                            border
                            size="mini"
                        ) {{ $t(field.label) }}
                    .field-section-label {{ $t('Field groups') }}
                    el-checkbox-group.field-chips(v-model="exportMembers.fields")
                        el-checkbox(
                            v-for="field in exportGroupFields"
                            :key="field.key"
                            :label="field.key"
                            border
                            size="mini"
                        ) {{ $t(field.label) }}
                    .field-hint {{ $t('The exported CSV can be imported again. Members with several addresses span several rows.') }}
            template(slot="footer")
                .modal-footer
                    .left
                        el-button(
                            v-for="button in bulk.modal.buttons.left"
                            :key="button.label"
                            v-if="button.action"
                            :size="button.size || 'mini'"
                            :type="button.type"
                            :plain="button.plain"
                            :icon="button.icon"
                            @click="button.action"
                        ) {{ button.label }}
                    .right
                        el-button(
                            v-for="button in bulk.modal.buttons.right"
                            :key="button.label"
                            v-if="button.action"
                            :size="button.size || 'mini'"
                            :type="button.type"
                            :plain="button.plain"
                            :icon="button.icon"
                            :disabled="button.disabled"
                            @click="button.action"
                        ) {{ button.label }}
</template>

<i18n>
{
    "en": {
        "Tags of {name}": "Tags of {name}",
        "Subscription Topics of {name}": "Subscription Topics of {name}",
        "Export persons...": "Export persons...",
        "Select fields to export": "Select fields to export",
        "The exported CSV can be imported again. Members with several addresses span several rows.": "The exported CSV can be imported again. Members with several addresses span several rows.",
        "Customer data": "Customer data",
        "Subscription topics": "Subscription topics",
        "Email verified": "Email verified",
        "No fields selected": "No fields selected",
        "Please select at least one field to export.": "Please select at least one field to export."
    },
    "de": {
        "New Person": "Neue Person",
        "CSV Customer Import": "CSV Kundenimport",
        "CSV Import": "CSV Import",
        "Show filters": "Filter anzeigen",
        "Hide filters": "Filter verbergen",
        "Person list could not be fetched.": "Personenliste konnte nicht abgerufen werden.",
        "Tags of {name}": "Tags von {name}",
        "Subscription Topics of {name}": "Abonnement-Themen von {name}",
        "Domain missing!": "Domain fehlt!",
        "This cms has no domain configured": "In diesem CMS wurde keine Domain konfiguriert",

        "Select bulk action...": "Massenaktion wählen...",
        "Go": "Ausführen",
        "Export persons...": "Personen exportieren...",
        "Select fields to export": "Felder für den Export wählen",
        "Export": "Exportieren",
        "Dismiss": "Abbrechen",
        "Select all": "Alle auswählen",
        "Deselect all": "Auswahl aufheben",
        "Basic fields": "Basis-Felder",
        "Field groups": "Feldgruppen",
        "The exported CSV can be imported again. Members with several addresses span several rows.": "Die exportierte CSV kann wieder importiert werden. Personen mit mehreren Adressen belegen mehrere Zeilen.",

        "ID": "ID",
        "Gender": "Geschlecht",
        "Salutation": "Anrede",
        "First name": "Vorname",
        "Last name": "Nachname",
        "Email": "E-Mail",
        "Phone": "Telefon",
        "Language": "Sprache",
        "Email verified": "E-Mail verifiziert",
        "Addresses": "Adressen",
        "Customer data": "Kundendaten",
        "Tags": "Tags",
        "Subscription topics": "Abonnement-Themen",

        "No fields selected": "Keine Felder ausgewählt",
        "Please select at least one field to export.": "Bitte mindestens ein Feld für den Export auswählen.",
        "Bulk action processed successfully!": "Massenaktion erfolgreich ausgeführt!",
        "Bulk action could not be processed.": "Massenaktion konnte nicht ausgeführt werden.",
        "Bulk action will be processed asynchronously": "Massenaktion wird asynchron verarbeitet",
        "You will be notified once the action is completed": "Sie werden benachrichtigt, sobald die Aktion abgeschlossen ist",
        "An error occurred!": "Ein Fehler ist aufgetreten!",
        "Status log could not be hidden.": "Status-Log konnte nicht ausgeblendet werden."
    }
}
</i18n>

<script>
import _ from 'lodash';
import { useSetupStore, useRestrictedAreaMemberStore } from '@/stores';

import { adminClient as apolloClient } from '@/store/apollo';
import { country } from '@/filters'
import router from '@/router';
import store from '@/store';
import pinia from '@/pinia';
import echo from '@/echo';

import MemberApi from '@/extensions/restrictedArea/store/api/member.js';
import { ensureFreshToken } from '@/helpers';
import StatusLogApi from '@/store/api/system/statusLog';

import PaginatedItems from '@/components/PaginatedItems';
import CheckAll from '@/components/CheckAll';
import StatusLog from '@/views/cms/Dashboard/widgets/logs/Partials/StatusLog';
import Tabs from '@/extensions/restrictedArea/views/Partials/Tabs';
import Error from '@/components/Error'

import CustomerTransfer from '@/extensions/shop/components/Customers/CustomerTransfer';
import CsvImport from '@/extensions/restrictedArea/components/MemberCsvImport';

export default {
    name: 'Members',
    data() {
        return {
            error: false,
            disable: {
                showFilters: false,
                customerTransfer: false,
            },
            visibleTransfer: undefined,
            // visibleImport: undefined,

            logs: [],
            loadingLogs: false,

            bulk: {
                action: undefined,
                options: [
                    { value: 'export-members', label: this.$t('Export persons...') },
                ],
                modal: {
                    visibility: false,
                    width: '520px',

                    title: undefined,
                    body: undefined,
                    buttons: {
                        left: [
                            {
                                size: 'mini',
                                icon: 'el-icon-fa-times fas',
                                label: this.$t('Dismiss'),
                                action: this.closeBulkModal,
                            }
                        ],
                        right: [],
                    }
                },
            },

            // the field keys match the columns of the member CSV import
            // so an exported file can be imported again
            exportMembers: {
                fields: ['id', 'first_name', 'last_name', 'email'],
                basicFields: [
                    { key: 'id', label: 'ID' },
                    { key: 'gender', label: 'Gender' },
                    { key: 'salutation', label: 'Salutation' },
                    { key: 'first_name', label: 'First name' },
                    { key: 'last_name', label: 'Last name' },
                    { key: 'email', label: 'Email' },
                    { key: 'phone', label: 'Phone' },
                    { key: 'language', label: 'Language' },
                    { key: 'email_verified', label: 'Email verified' },
                ],
                groupFields: [
                    { key: 'addresses', label: 'Addresses' },
                    { key: 'customer', label: 'Customer data', requiresShop: true },
                    { key: 'tags', label: 'Tags' },
                    { key: 'subscription_topics', label: 'Subscription topics' },
                ],
            },
        };
    },
    components: {
        PaginatedItems,
        CheckAll,
        StatusLog,
        CustomerTransfer,
        CsvImport,
        Error,
        Tabs
    },
    watch: {
        activeCms(cms) {
            const reload = _.get(cms, 'reloadComponents', true);
            if (reload) this.initialize();
        }
    },
    computed: {
        // the customer fields only exist if the CMS has a shop
        exportGroupFields() {
            const hasShop = this.enabledExtensions.includes('shop');
            return this.exportMembers.groupFields.filter(el => !el.requiresShop || hasShop);
        },
        allExportFieldsSelected() {
            const allKeys = [
                ...this.exportMembers.basicFields.map(f => f.key),
                ...this.exportGroupFields.map(f => f.key),
            ];
            return allKeys.every(k => this.exportMembers.fields.includes(k));
        },
        bulkSelection() {
            let checked = 'none';
            const total = _.get(this.membersPaginated, 'pageInfo.total') || 0;

            const selection = this.membersPaginated.pageInfo.selection;

            if (selection.type === 'exclusive' && selection.identifiers.length < total) checked = 'all';
            else if (selection.type === 'inclusive' && selection.identifiers.length) checked = 'visible';

            return checked;
        },
        selectionIndeterminate() {
            let indeterminate = false;

            const selection = this.membersPaginated.pageInfo.selection;

            if (selection.type === 'exclusive' && selection.identifiers.length) indeterminate = true;
            else if (selection.type === 'inclusive' && selection.identifiers.length) {
                const items = _.get(this.membersPaginated, 'items') || [];
                const currentPageSelection = items.filter(el => selection.identifiers.includes(parseInt(el.id)));
                indeterminate = currentPageSelection.length < items.length;
            }
            return indeterminate;
        },
        checkAllEvent() {
            let event = 'check-all';
            if (this.hasFilters) event = 'check-visible';
            return event;
        },
        impersonateFeatureEnabled() {
            let features = _.get(this.activeCms, 'config.template.features') || [];
            return !!features.find(el => el === 'impersonate-member');
        },
        mimicFeatureEnabled() {
            let features = _.get(this.activeCms, 'config.template.features') || [];
            return !!features.find(el => el === 'mimic-members');
        },
        showFilters() {
            return this.hasFilters || _.get(this.membersPaginated, 'showFilters') || false;
        },
        hasFilters() {
            return !_.isEmpty(this.filters);
        },
        filters() {
            let filters = _.cloneDeep(this.membersPaginated.filters);
            delete filters.cms;
            return filters;
        },
        sort() {
            var variables = this.membersPaginated.variables;
            var defaultSort = this.membersPaginated.defaultSort;
            var order = _.get(variables, 'order') || _.get(defaultSort, 'field') || 'id';
            var direction = _.get(variables, 'direction') || _.get(defaultSort, 'direction') || 'asc';
            return { field: order, direction: direction };
        },
        allColumns() {
            let allColumns = this.membersPaginated.allColumns;

            if (!this.enabledExtensions.includes('shop')) {
                allColumns = allColumns.filter(el => el.value_path.startsWith('customer.') === false);
            }

            return allColumns;
        },
        activeColumns() {
            let activeColumns = this.membersPaginated.activeColumns;

            if (!this.enabledExtensions.includes('shop')) {
                activeColumns = activeColumns.filter(el => el.value_path.startsWith('customer.') === false);
            }

            return activeColumns;
        },
        memberTransfers() {
            const settings = this.settingValues;

            let transfers = [];
            if (this.enabledExtensions.includes('restricted-area')) {
                const imports = _.get(this.activeCms, 'config.template.restrictedArea.import.members') || [];
                const exports = _.get(this.activeCms, 'config.template.restrictedArea.export.members') || [];
                transfers = [
                    ...imports.map(el => ({ ...el, type: 'import' })),
                    ...exports.map(el => ({ ...el, type: 'export' })),
                ];
            }

            let allowed = [];
            transfers.forEach(el => {
                let valid = true;
                try {
                    const conditions = el.conditions;
                    if (conditions && conditions.length) {
                        conditions.forEach(o => {
                            if (valid === false) return;

                            const { type, condition } = o;
                            switch (type) {
                                case 'eval':
                                    valid = eval(condition);
                                    break;

                                default:
                                    valid = false;
                            }
                        });
                    }
                } catch (error) {
                    console.error(error);
                    valid = false;
                }

                if (valid) allowed.push(el);
            });

            return allowed;
        },
        customerTransfers() {
            const settings = this.settingValues;

            let transfers = [];
            if (this.enabledExtensions.includes('shop')) {
                const imports = _.get(this.activeCms, 'config.template.shop.import.customers') || [];
                const exports = _.get(this.activeCms, 'config.template.shop.export.customers') || [];
                transfers = [
                    ...imports.map(el => ({ ...el, type: 'import' })),
                    ...exports.map(el => ({ ...el, type: 'export' })),
                ];
            }

            let allowed = [];
            transfers.forEach(el => {
                let valid = true;
                try {
                    const conditions = el.conditions;
                    if (conditions && conditions.length) {
                        conditions.forEach(o => {
                            if (valid === false) return;

                            const { type, condition } = o;
                            switch (type) {
                                case 'eval':
                                    valid = eval(condition);
                                    break;

                                default:
                                    valid = false;
                            }
                        });
                    }
                } catch (error) {
                    console.error(error);
                    valid = false;
                }

                if (valid) allowed.push(el);
            });

            return allowed;
        },
        activeCms() {
            return useSetupStore().activeCms;
        },
        enabledExtensions() {
            return useSetupStore().enabledExtensions;
        },
        settingValues() {
            return useSetupStore().settingValues;
        },
        debounce() {
            return useSetupStore().debounce;
        },
        memberStore() {
            return useRestrictedAreaMemberStore();
        },
        loading() {
            return this.memberStore.loading;
        },
        membersPaginated() {
            return this.memberStore.membersPaginated;
        },
        setupStore() {
            return useSetupStore(pinia);
        },
        csvImportLabel() {
            if (this.enabledExtensions.includes('shop')) {
                return 'CSV Customer Import';
            }
            return 'CSV Import';
        },
    },
    methods: {
        country(i) {
            const language = 'de'
            return country(i, language)
        },
        // toggleCsvImportForm() {
        //     const config = { key: 'csv' };
        //
        //     let visibleImport = { config };
        //     if (this.visibleImport && this.visibleImport.config.key === config.key) visibleImport = undefined;
        //     this.visibleImport = visibleImport;
        // },
        toggleTransferForm(config, scope) {
            let visibleTransfer = { scope, config };

            if (
                this.visibleTransfer &&
                this.visibleTransfer.scope === scope &&
                this.visibleTransfer.config.key === config.key
            ) {
                visibleTransfer = undefined;
            }

            this.visibleTransfer = visibleTransfer;
        },
        initialize() {
            this.updateLoading(true);
            this.resetBulkSelection();
            this.initializeStatusLogSubscription();
            this.refetch();
        },
        isChecked(id) {
            let checked = false;

            const selection = this.membersPaginated.pageInfo.selection;
            switch (selection.type) {
                case 'inclusive':
                    checked = !!~selection.identifiers.map(el => parseInt(el)).indexOf(parseInt(id));
                    break;

                case 'exclusive':
                    checked = !~selection.identifiers.map(el => parseInt(el)).indexOf(parseInt(id));
                    break;
            }
            return checked;
        },
        toggleAllExportFields() {
            if (this.allExportFieldsSelected) {
                this.exportMembers.fields = [];
            } else {
                this.exportMembers.fields = [
                    ...this.exportMembers.basicFields.map(f => f.key),
                    ...this.exportGroupFields.map(f => f.key),
                ];
            }
        },
        closeBulkModal() {
            this.bulk.modal.visibility = false;
        },
        resetBulkModal() {
            this.bulk.modal = {
                visibility: false,
                width: '520px',

                title: undefined,
                body: undefined,
                buttons: {
                    left: [
                        {
                            size: 'mini',
                            icon: 'el-icon-fa-times fas',
                            label: this.$t('Dismiss'),
                            action: this.closeBulkModal,
                        }
                    ],
                    right: [],
                }
            };
        },
        handleBulkAction(action = undefined) {
            action = action || this.bulk.action;

            // the response tells us what to do next:
            // either the file is ready right away
            // or the export is processed asynchronously
            const completeRequest = ({ actions, data }) => {
                let promises = [];

                if (actions && actions.length) {
                    actions.forEach((action, i) => {
                        switch (action) {
                            case 'download-file':
                                promises.push(
                                    ensureFreshToken().then((token) => {
                                        if (!data || !data.length || !data[i]) throw new Error('missing file in response');

                                        const file = data[i].split('/');
                                        const item = { id: file[0], name: file[1] };

                                        const storageRoute = _.trim(
                                            `${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PRIVATE_STORAGE_ROUTE}`,
                                            '/'
                                        );
                                        const link = `${storageRoute}/files/${item.id}/${encodeURIComponent(item.name)}?download&token=${token}`;

                                        let element = document.createElement('a');
                                        element.setAttribute('href', link);
                                        element.style.display = 'none';
                                        document.body.appendChild(element);
                                        element.click();
                                        document.body.removeChild(element);
                                    })
                                );
                                break;

                            case 'await-event-broadcast':
                                this.$notify.success({
                                    title: this.$t('Bulk action will be processed asynchronously'),
                                    message: this.$t('You will be notified once the action is completed'),
                                    iconClass: 'fas el-icon-fa-check',
                                    position: 'bottom-left',
                                    customClass: 'dark',
                                    duration: 8000
                                });
                                break;
                        }
                    });
                }

                return Promise.all(promises);
            };

            switch (action) {
                case 'export-members':
                    this.bulk.modal.title = this.$t('Select fields to export');
                    this.bulk.modal.width = '520px';
                    this.bulk.modal.buttons.right = [
                        {
                            size: 'mini',
                            type: 'primary',
                            icon: 'el-icon-fa-file-csv fas',
                            label: this.$t('Export'),
                            action: () => this.handleBulkAction('export-members:run'),
                        },
                    ];
                    this.bulk.modal.visibility = true;
                    break;

                case 'export-members:run':
                    if (!this.exportMembers.fields.length) {
                        this.$notify.error({
                            title: this.$t('No fields selected'),
                            message: this.$t('Please select at least one field to export.'),
                            iconClass: 'fas el-icon-fa-times',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000
                        });
                        break;
                    }

                    this.bulk.modal.visibility = false;
                    this.updateLoading(true);

                    this.processPaginationBulkAction('export-members', {
                        fields: this.exportMembers.fields,
                    })
                        .then(data => {
                            completeRequest(data)
                                .then(() => {
                                    if (data.actions.includes('download-file')) {
                                        this.$notify.success({
                                            title: this.$t('Bulk action processed successfully!'),
                                            iconClass: 'fas el-icon-fa-check',
                                            position: 'bottom-left',
                                            customClass: 'dark',
                                            duration: 8000
                                        });
                                    }
                                })
                                .finally(() => this.updateLoading(false));
                        })
                        .catch(err => {
                            console.error(err);
                            this.updateLoading(false);
                            this.$notify.error({
                                title: this.$t('An error occurred!'),
                                message: this.$t('Bulk action could not be processed.'),
                                iconClass: 'fas el-icon-fa-times',
                                position: 'bottom-left',
                                customClass: 'dark',
                                duration: 8000
                            });
                        });
                    break;
            }
        },
        initializeStatusLogSubscription() {
            if (!echo.client) {
                setTimeout(() => this.initializeStatusLogSubscription(), 10);
            } else {
                this.fetchRelatedStatusLogs();

                echo.client.private('cms.' + this.activeCms.id)
                    .listen('.status-log:created', async data => {
                        if (data.log && data.log.key === 'export-members-to-csv') {
                            const exists = this.logs.find(log => parseInt(log.id) === parseInt(data.log.id));

                            if (!exists) {
                                const logs = await StatusLogApi.fetchList({
                                    id: data.log.id,
                                    cms: parseInt(this.activeCms.id),
                                    status: ['info', 'success', 'warning', 'error'],
                                    key: ['export-members-to-csv'],
                                    hide: false,
                                });

                                if (logs && logs.length) {
                                    this.logs = _.uniqBy(_.orderBy([...logs, ...this.logs], 'created_at', 'desc'), 'id');
                                }
                            }
                        }
                    })
                    .listen('.status-log:updated', async data => {
                        if (data.log && data.log.key === 'export-members-to-csv') {
                            const index = this.logs.findIndex(log => parseInt(log.id) === parseInt(data.log.id));

                            if (index >= 0) {
                                if (data.log.hide) {
                                    this.logs = this.logs.filter(log => parseInt(log.id) !== parseInt(data.log.id));
                                } else {
                                    this.$set(this.logs[index], 'status', data.log.status);
                                    this.$set(this.logs[index], 'progress', data.log.progress);
                                    this.$set(this.logs[index], 'updated_at', data.log.updated_at);
                                    this.$set(this.logs[index], 'heading', data.log.heading);
                                    this.$set(this.logs[index], 'body', data.log.body);
                                    this.$set(this.logs[index], 'data', data.log.data);
                                    this.$set(this.logs[index], 'hide', data.log.hide);
                                    this.$set(this.logs[index], 'file', data.log.file);
                                }
                            } else {
                                const logs = await StatusLogApi.fetchList({
                                    id: data.log.id,
                                    cms: parseInt(this.activeCms.id),
                                    status: ['info', 'success', 'warning', 'error'],
                                    key: ['export-members-to-csv'],
                                    hide: false,
                                });

                                if (logs && logs.length) {
                                    this.logs = _.uniqBy(_.orderBy([...logs, ...this.logs], 'created_at', 'desc'), 'id');
                                }
                            }
                        }
                    });
            }
        },
        fetchRelatedStatusLogs() {
            const variables = {
                cms: parseInt(this.activeCms.id),
                status: ['info', 'success', 'warning', 'error'],
                key: ['export-members-to-csv'],
                hide: false,
                skip: 0,
                take: 10,
            };

            StatusLogApi.fetchList(variables)
                .then(logs => (this.logs = logs))
                .catch(err => console.error(err));
        },
        hideStatusLog(log) {
            this.loadingLogs = true;

            log = _.cloneDeep(log);
            if (log.file) delete log.file;
            log.hide = true;

            StatusLogApi.update(log)
                .then(data => {
                    if (data.hide) {
                        this.logs = this.logs.filter(el => el.id !== log.id);
                    } else {
                        this.$notify.error({
                            title: this.$t('An error occurred!'),
                            message: this.$t('Status log could not be hidden.'),
                            iconClass: 'fas el-icon-fa-times',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000
                        });
                    }
                })
                .catch(err => {
                    console.error(err);
                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: this.$t('Status log could not be hidden.'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                })
                .finally(() => (this.loadingLogs = false));
        },
        async refreshCustomerTransfer() {
            this.disable.customerTransfer = true
            await this.refetch();
            this.disable.customerTransfer = false
        },
        addMember() {
            const params = { id: 'new' };
            router.push({ name: 'member-main', params });
        },
        handleClick(item) {
            const params = { id: item.id };
            router.push({ name: 'member-main', params });
        },
        handleSizeChange(itemsPerPage) {
            this.updateLoading(true);
            this.defineItemsPerPage(itemsPerPage);
            this.refetch();
        },
        handleCurrentChange(currentPage) {
            this.updateLoading(true);
            this.defineCurrentPage(currentPage);
            this.refetch();
        },
        handleColsShow(visibleColumns) {
            this.defineActiveColumns(visibleColumns);
            // apolloClient.cache.reset()
            apolloClient.clearStore();
        },
        handleFilterInputChange(key, value, debounce = true) {
            //reset currentPage if filtering to find entries on all pages
            this.defineCurrentPage(0)

            this.defineFilterValue({ key, value });
            if (debounce) this.debouncedRefetch();
            else this.refetch();
        },
        handleSortInputChange(key, value) {
            this.defineSort({ key, value });
            this.refetch();
        },
        toggleFilterVisiblity() {
            const visible = this.showFilters;

            let value = false;
            if (!visible) value = true;

            this.disable.showFilters = true;
            this.defineFilterVisibility(value);
            this.saveFilterVisibility({ scope: 'ex', key: 'rstrct_member', value }).finally(
                () => (this.disable.showFilters = false)
            );
        },
        impersonateMember(id, redirect = true) {
            const domains = this.activeCms.domains || [];
            const domain = domains.find(el => !!el.base_url);

            if (!domain) {
                this.$notify.error({
                    title: this.$t('Domain missing!'),
                    message: this.$t('This cms has no domain configured'),
                    iconClass: 'fas el-icon-fa-times',
                    position: 'bottom-left',
                    customClass: 'dark',
                    duration: 8000
                });
            } else {
                MemberApi.generateImpersonationToken(id)
                    .then(({ data }) => {
                        if (!data.token) {
                            this.$notify.error({
                                title: this.$t('Something went wrong!'),
                                iconClass: 'fas el-icon-fa-times',
                                position: 'bottom-left',
                                customClass: 'dark',
                                duration: 8000
                            });
                        } else {
                            if (redirect) {
                                window.open(`//${domain.base_url}?token=${data.token}`, '_blank');
                            } else {
                                this.$notify.success({
                                    title: this.$t('URL'),
                                    message: `${domain.base_url}?token=${data.token}`,
                                    iconClass: 'fas el-icon-fa-times',
                                    position: 'bottom-left',
                                    customClass: 'dark',
                                    // duration: 8000
                                });
                            }
                        }
                    })
                    .catch(error => {
                        console.error(error);
                        this.$notify.error({
                            title: this.$t('An error occurred!'),
                            iconClass: 'fas el-icon-fa-times',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000
                        });
                    });
            }
        },
        mimicMember(id, redirect = true) {
            const domains = this.activeCms.domains || [];
            const domain = domains.find(el => !!el.base_url);

            if (!domain) {
                this.$notify.error({
                    title: this.$t('Domain missing!'),
                    message: this.$t('This cms has no domain configured'),
                    iconClass: 'fas el-icon-fa-times',
                    position: 'bottom-left',
                    customClass: 'dark',
                    duration: 8000
                });
            } else {
                MemberApi.loginAs(id)
                    .then(({ data }) => {
                        if (!data.token) {
                            this.$notify.error({
                                title: this.$t('Something went wrong!'),
                                iconClass: 'fas el-icon-fa-times',
                                position: 'bottom-left',
                                customClass: 'dark',
                                duration: 8000
                            });
                        } else {
                            if (redirect) {
                                window.open(`//${domain.base_url}?token=${data.token}`, '_blank');
                            } else {
                                this.$notify.success({
                                    title: this.$t('URL'),
                                    message: `${domain.base_url}?token=${data.token}`,
                                    iconClass: 'fas el-icon-fa-times',
                                    position: 'bottom-left',
                                    customClass: 'dark',
                                    // duration: 8000
                                });
                            }
                        }
                    })
                    .catch(error => {
                        console.error(error);
                        this.$notify.error({
                            title: this.$t('An error occurred!'),
                            iconClass: 'fas el-icon-fa-times',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000
                        });
                    });
            }
        },
        refetch() {
            this.updateLoading(true);
            // always add the cms id to filters
            const cmsID = this.activeCms.id;
            const filter = {
                key: 'cms',
                match: cmsID
            };
            this.defineFilterValue({ key: 'cms', value: filter });

            return this.fetchMembersPaginated()
                .then(() => this.updateLoading(false))
                .catch(err => {
                    const { graphQLErrors } = err

                    let code = 501;
                    let message = 'An error occurred!';

                    if (graphQLErrors) {
                        code = _.get(graphQLErrors, '0.code') || code;
                        message = _.get(graphQLErrors, '0.message') || message;
                    }

                    let notify = true;
                    switch (code) {
                        case 401:
                            notify = false;
                            this.error = { code, message: 'You are not authorized' };
                            break;
                        case 403:
                            notify = false;
                            this.error = { code, message: 'You are not allowed to be here' };
                            break;
                        // case 404:
                        //     break;
                        default:
                            this.error = true;
                            break;
                    }

                    if (notify) {
                        this.$notify.error({
                            title: this.$t(message),
                            message: this.$t('Person list could not be fetched.'),
                            iconClass: 'fas el-icon-fa-times',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000
                        });
                    }

                    this.updateLoading(false);

                    /* eslint no-console: ["error", { allow: ["error"] }] */
                    console.error(err);
                });
        },
        debouncedRefetch: _.debounce(function () {
            // function scope is needed here
            this.updateLoading(true);
            this.refetch();
        }, useSetupStore(pinia).debounce || 300),
        activateTab(item) {
            return useSetupStore().activateTab(item);
        },
        fetchMembersPaginated() {
            return this.memberStore.fetchMembersPaginated();
        },
        updateLoading(value) {
            this.memberStore.updateLoading(value);
        },
        defineItemsPerPage(itemsPerPage) {
            this.memberStore.defineItemsPerPage(itemsPerPage);
        },
        defineCurrentPage(currentPage) {
            this.memberStore.defineCurrentPage(currentPage);
        },
        defineActiveColumns(visibleColumns) {
            this.memberStore.defineActiveColumns(visibleColumns);
        },
        defineFilterValue(payload) {
            this.memberStore.defineFilterValue(payload);
        },
        defineFilterVisibility(value) {
            this.memberStore.defineFilterVisibility(value);
        },
        defineSort(payload) {
            this.memberStore.defineSorting(payload);
        },
        processPaginationBulkAction(action, options) {
            return this.memberStore.processPaginationBulkAction(action, options);
        },
        checkAll(payload) {
            return this.memberStore.paginationBulkSelectionCheckAll(payload);
        },
        checkVisible(payload) {
            return this.memberStore.paginationBulkSelectionCheckVisible(payload);
        },
        checkItem(item) {
            return this.memberStore.paginationBulkSelectionCheckItem(item);
        },
        resetBulkSelection() {
            return this.memberStore.paginationBulkSelectionReset();
        },
        saveFilterVisibility(payload) {
            return this.setupStore.saveFilterVisibility(payload);
        }
    },
    mounted() {
        this.initialize();
    },
    beforeDestroy() {
        if (echo.client) {
            echo.client.private(`cms.${this.activeCms.id}`)
                .stopListening('.status-log:created')
                .stopListening('.status-log:updated');
        }
    },
};
</script>

<style lang="sass" scoped>
.table-top
    display: block
    .row
        display: flex
        justify-content: space-between
    .transfer
        margin-top: .5rem

.error
    padding: 20px
.tags
    display: flex
    align-items: center
    flex-wrap: wrap
    gap: 4px
    .el-tag + .el-tag
        margin-left: 0
.popover-body
    max-width: 360px

.export-members-fields
    .field-section-header
        display: flex
        justify-content: space-between
        align-items: center
        margin-bottom: 8px
    .field-section-label
        font-weight: 600
        font-size: 13px
        margin-bottom: 8px
        &:not(:first-child)
            margin-top: 16px
    .field-chips
        display: flex
        flex-wrap: wrap
        gap: 4px
        .el-checkbox
            margin-right: 0
            margin-left: 0
            padding: 4px 14px 4px 6px
            height: 28px
    .field-hint
        margin-top: 16px
        font-size: 12px
        opacity: .7
.mimic-button,
.impersonate-button
    padding: 0
    width: 28px
    height: 28px
    font-size: 0.85rem
    &[disabled]
        pointer-events: none
    &:not([disabled]):hover
        background: $--color-primary
        border-color: $--color-primary
        color: white
</style>
